import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_ALL_PATIENT_CHALLENGES_BY_ID_KEY } from '_api/queries/challenge/useGetAllPatientChallengesByID';
import { GET_CHALLENGE_REPORT_ID } from '_api/queries/challenge/useGetChallengeReport';
import { AddChallengeToPatientPayload } from '_api/types';

export const UPDATE_CHALLENGE_TO_PATIENT_KEY = 'update-challenge-to-patient';

export const useUpdateChallengeToPatient = () => {
  const queryClient = useQueryClient();
  return useApiMutation<AddChallengeToPatientPayload, AddChallengeToPatientPayload>(
    () => '/challenge/update-patient-challenge-setting',
    'put',
    {},
    {
      mutationKey: [UPDATE_CHALLENGE_TO_PATIENT_KEY],
      onSuccess: ({ id }) => {
        queryClient.invalidateQueries({
          queryKey: [GET_ALL_PATIENT_CHALLENGES_BY_ID_KEY],
        });
        queryClient.invalidateQueries({
          queryKey: [GET_CHALLENGE_REPORT_ID, id],
        });
      },
    },
  );
};
